module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogFiltersMobile":{"displayCatalogFilters":"Filtrovat"}}}')
  delete Component.options._Ctor
}
